import {
    REPORT_SEND_RESPONSE, REPORT_SEND_FAILURE, BITALY_LINK_RESPONSE, BITALY_LINK_FAILURE
} from "../types/reports";

const initialState = {
    Bitaly_link: {},
    ReportSend: {}
}

export default function reducer(state = initialState, action) {
    switch (action.type) {

        case REPORT_SEND_RESPONSE:
            return { ...state, ReportSend: action.payload }
        case REPORT_SEND_FAILURE:
            return { ...state, ReportSend: action.payload }

        case BITALY_LINK_RESPONSE:
            return { ...state, Bitaly_link: action.payload }
        case BITALY_LINK_FAILURE:
            return { ...state, Bitaly_link: action.payload }

        default:
            return state
    }

}